import Vue from 'vue';
import VueRouter from 'vue-router';

import routes from './config';
import beforeMiddlewares from './before-middlewares';
import registerBeforeMiddlewares from './utils/registerBeforeMiddlewares';

import { PREFIX_PATH } from '@/config';

Vue.use(VueRouter);

export const routerConfig = {
  routes,
  base: PREFIX_PATH,
  mode: 'history',
  scrollBehavior(
    to,
    from,
    savedPosition = {
      x: 0,
      y: 0,
    },
  ) {
    return savedPosition;
  },
};

const router = new VueRouter(routerConfig);

registerBeforeMiddlewares(router, beforeMiddlewares);

export default router;
